import React from "react";
import { Instagram, Facebook, Heart, MapPin } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { BRAND_LOGO_URL } from "@/data/content";

const Footer = () => {
    const { t } = useLanguage();
    const f = t.footer;

    return (
        <footer
            data-testid="site-footer"
            className="bg-foreground text-background pt-16 md:pt-24 pb-10"
        >
            <div className="container-x">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pb-12 border-b border-white/10">
                    <div className="md:col-span-4">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-full bg-background overflow-hidden">
                                <img
                                    src={BRAND_LOGO_URL}
                                    alt="BrowsEMS"
                                    className="w-8 h-8 object-cover"
                                />
                            </span>
                            <span className="font-heading text-2xl">BrowsEMS</span>
                        </div>
                        <p className="font-body text-background/70 text-sm max-w-xs leading-relaxed">{f.tagline}</p>
                        <p className="font-body text-background/50 text-xs mt-4 flex items-center gap-1.5">
                            <MapPin size={11} /> Boca Raton · Fort Lauderdale · Miami
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href="#"
                                aria-label="Instagram"
                                data-testid="footer-instagram"
                                className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors"
                            >
                                <Instagram size={15} />
                            </a>
                            <a
                                href="#"
                                aria-label="Facebook"
                                data-testid="footer-facebook"
                                className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors"
                            >
                                <Facebook size={15} />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="font-body text-[11px] tracking-[0.3em] uppercase text-background/50 mb-4">
                            {f.services}
                        </h4>
                        <ul className="space-y-2">
                            {f.links.services.map((l) => (
                                <li key={l}>
                                    <a
                                        href="/#services"
                                        className="font-body text-sm text-background/80 hover:text-primary transition-colors"
                                    >
                                        {l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="font-body text-[11px] tracking-[0.3em] uppercase text-background/50 mb-4">
                            {f.studio}
                        </h4>
                        <ul className="space-y-2">
                            {f.links.studio.map((l) => (
                                <li key={l}>
                                    <a
                                        href="/#artists"
                                        className="font-body text-sm text-background/80 hover:text-primary transition-colors"
                                    >
                                        {l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="font-body text-[11px] tracking-[0.3em] uppercase text-background/50 mb-4">
                            {f.help}
                        </h4>
                        <ul className="space-y-2">
                            {f.links.help.map((l) => (
                                <li key={l}>
                                    <a
                                        href="/#contact"
                                        className="font-body text-sm text-background/80 hover:text-primary transition-colors"
                                    >
                                        {l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="font-body text-xs text-background/50">{f.rights}</p>
                    <p className="font-body text-xs text-background/50 text-center">{f.badge}</p>
                    <p className="font-body text-xs text-background/50 flex items-center gap-1.5">
                        Made with <Heart size={11} className="text-primary fill-primary" /> in South Florida
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
